import { render, staticRenderFns } from "./InvoiceEntry.vue?vue&type=template&id=06fbfd54&scoped=true"
import script from "./InvoiceEntry.vue?vue&type=script&lang=js"
export * from "./InvoiceEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fbfd54",
  null
  
)

export default component.exports